<template>
    <el-row class="mg-b5">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item class="my-form-item">
                        <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                            v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
                            style="width: 200px" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
                            style="width: 160px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                        <el-button size="mini" type="primary" @click="onSearch" >查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 订单列表 -->
            <OrderTable
				ref="OrderTableRef"
                :pageFlag="pageFlag"
                :tableData="tableData"
                @callback="OrderTableCallback"
                :currencyObj="currencyInfo.obj"
                :count="count"
				:loading="loading"
                :tableHeight="PAGESIZE.h-290" />
        </el-card>
    </el-row>
</template>

<script>
	import {
		inquiryList,
		addInquiry,
		editInquiry,
		delInquiry,
		batchDelInquiry,
		exportInquiry,
	} from '@/api/srm/inquiry.js'
	import { gysInquiryList } from '@/api/quote/index.js'
	import OrderTable from '@/components/OrderTable'
	import { addInquiryUser,joinInquiry,giveUpInquiry } from '@/api/srm/inquiryUser.js'
	import { submitOrderBj } from '@/api/srm/inquiryDetail.js'
	export default {
		props:['pageFlag'],
		name: "inquiryAll",
		components:{
			OrderTable
		},
		computed: {
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
			userInfo:function(){
				return this.$store.getters['user/user'];
			},
		},
		data() {
			return {
				loading:false,
				title: "",
				tableData: [],
				ids: [],
				form: {},
				activeNames: ['1'],
				loadingInstance: undefined,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						gysOrderState:1,		 // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标,
					}
				},
			};
		},
		created() {
			this.quertInfo.objMap.gysOrderState = this.getOrderStatus(this.pageFlag);
			this.getList();
			console.log(this.userInfo)
		},
		methods: {
			getOrderStatus(type){
				let state = '';
				if(this.pageFlag == 'all'){
					state = '';
				}
				if(this.pageFlag == 'onJoin'){
					state = 1;
				}
				if(this.pageFlag == 'giveUp'){
					state = 2;
				}
				if(this.pageFlag == 'joining'){
					state = 3;
				}
				if(this.pageFlag == 'submit'){
					state = 4;
				}
				if(this.pageFlag == 'bidding'){
					state = 5;
				}
				if(this.pageFlag == 'unBidding'){
					state = 6;
				}

				return state
			},
			OrderTableCallback: function(obj){
				if(obj.type == 'pagination'){	// 页码改变
					this.quertInfo.page = obj.info.page;
					this.quertInfo.limit = obj.info.limit;
					this.getList();
				}
				if(obj.type == 'enquiry'){	// 询价详情
					this.handleEnquiry(obj.info)
				}
				if(obj.type == 'selecttable'){
					this.ids = obj.info;
				}
				if(obj.type == 'abandon'){	// 放弃
					this.handleFq(obj.info)
				}
				if(obj.type == 'join'){	// 参与
					this.handleCy(obj.info)
				}
				if( obj.type == 'submitQuote'){
					 let _this = this;
					_this.confirm({
						text: '报价一经提交，将无法撤回修改，请再次确认报价无误',
						tip: '警告',
						type: '',
						fn: function(param) {
							submitOrderBj(param).then(({data:res})=>{
								if(res.code == 0){
									_this.$success('提交成功');
									_this.getList();
								}
							})
						},
						data: {
							id:obj.info.inquiryUserId
						} //参数对象 主要回调函数用
					});
				}
			},
			 //参与价单
			handleCy: function(row) {
				let _this = this;
				joinInquiry({
					id: row.inquiryUserId,
					inquiryId: row.id,
				}).then(response => {
					if (response.data.code === 0) {
						_this.$success(response.data.msg);
						_this.getList();
					} else {
						_this.$fail(response.data.msg);
					}
				});
			},
			//放弃询价单
			handleFq: function(row) {
				let _this = this;
				_this.confirm({
					text: '是否确认放弃？',
					tip: '警告',
					type: '',
					fn: function(param) {
						giveUpInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: { //参数对象 主要回调函数用
						id: row.inquiryUserId,
						inquiryId: row.id,
					 }
				});
			},
			// 发起询价
			handleEnquiry:function(row){
				this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${row.id}&show=false`});
			},
			async getList() {
				let _this = this;
				_this.loading = true;
				const {
					data: res
				} = await gysInquiryList(_this.quertInfo)
				_this.loading = false;
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			handleBatchDel: function() {
				//批量删除
				let _this = this;
				if (_this.ids.length <= 0) {
					_this.$fail("请勾选要删除的行数据");
					return false;
				}
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						batchDelInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						ids: _this.ids
					} //参数对象 主要回调函数用
				});
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '全部导出',
					but2: '当前页',
					type: '',
					fn: function() {
						let param = JSON.parse(JSON.stringify(_this.quertInfo));
						param.page = 0;
						exportInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportInquiry(_this.quertInfo).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			handleAvatarExcel(res, file) {
				if (res.code == 0) {
					this.getList();
				}
				this.loadingInstance.close();
				this.$success(res.msg);
			},
			beforeExcel(file) {
				// 判断文件后缀
				let type = file.name.substring(file.name.lastIndexOf('.') + 1);
				if (!(type == "xls" || type == "xlsx")) {
					this.$fail('请导入Excel文件');
					return false;
				}

				const isLt2M = file.size / 1024 / 1024 <= 1;
				if (!isLt2M) {
					this.$fail('导入Excel不能超过 1MB!');
					return false;
				}
				this.loadingInstance = this.Loading({
					text: '导入中请等待...'
				});
			},

		},
		watch:{
			pageFlag:function(val){
				console.log(val)
				this.quertInfo={
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						gysOrderState:this.getOrderStatus(val),		 // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标,
					}
				};
				this.getList();
			}
		}
	};
</script>
<style scoped="scoped">
</style>
